module.exports = __webpack_public_path__ + "media/1x1/gy-0653b318.svg";